export const NGDI_TABS = [
  { title: 'My Work Basket', route: '/MyWorkBasket' },
  { title: 'Workflow', route: '/Workflow' },
  { title: 'Retrieval', route: '/Retrieval' },
  { title: 'Web Upload', route: '/Webupload' }
];
export const userPreference = {
    userNameDisplay: "User FullName Display",
    SendToWorkflow: "Send to Workflow",
    emailNotification: "Email Notification",
    RoutingInWorkflow: "Routing in Workflow",
    DateFormatDisplay: "Date Format Display",
    Timezone: "Timezone",
    DisplayInboxFields: "Display Inbox Fields In Workflow",
    SortingOption: "Sorting Option",
    SortingProperty: "Sorting Property",
    WorkItemCount: "WorkItem Count",
    GetNextWorkItem: "GetNextWorkitem Property",
  };